// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2025-12-11T11:33:51+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  190785
//    Project:        617
//    Environment:    7626 - master
//    MD5:            32fe3f917217b3d46bacc700f371322d
//    Signature:      eyJpdiI6InZHU01vUEk1SmQxTjdyVkF5ZEMwZEE9PSIsInZhbHVlIjoiNlNsRUs0SWhuaWtlenFSeEdZaUhPZUJHNTRwM1Jyek5LbWhwbDE2b0xkQW9ZclJqdzV0YVlqdGZJdlFNU2xEZCt0RUU4OEttSzBDN2d4WHNXTFRpUVIzM3lFN3dRcm9hZ1lRTmVyMjN0c2FvTDlBME9hcGluN2czdGttNjZcLzFDMWdZMkVXZkU5K1dMa1FBa2RDdjdsTmU4NDlJVUlsSVN5OFN1U2dUTzZraXlISjJTZzZ6UnlsNnF1UUdRR05SV1R1YWYyc3NaNTNSTnErMGJOY2RSMUtDaFwvNXAyTUNYbEgyZ0t6UFwvZHlcL0pRc1dacG1cLzlRK2pLZzZjc2RSR3JWK2NlMzNCSnhhRngzRExrUXJBbkl1cFFKRFdvUDZ5VUMxM1hLVEVRc3VXcGs3MW0rUVR2MzBPbCtqbmZwN3c4NnpHc1N6enFRZTFBN2l6OHlcL1VkTW5pbUk4VVJleER1RFNtQTFRYnhYWERqWkMxTjVNK1FOSHpKUmVDeWVlVnRzZnBMSkJxNEpxcmV0VDloWDZiWDQzdz09IiwibWFjIjoiOTJmNzk1MTQ2OTA2YzljMWFjM2QwNjRiYTk5NTY3M2VkNThiNTU3Yjk5ZmNjZmQ2NjE3ZDUyM2VkOGFhNjhmOSJ9
let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}
